import React from 'react';
import { Layout } from 'antd';
import { Sidebar } from '../../../Components/Sidebar/Sidebar';
import { HeaderBar } from '../../../Components/Header/Header';
import PageContentHeader from '../../../Components/CoreComponents/PageContentHeader';
import OrganizationFormComponent from '../../../Components/CoreComponents/OrganizationFormComponent';

import '../Organization.css';

const { Content } = Layout;

export const EditOrganization = () => {
  return (
    <>
      <Layout className="layout_wrapper">
        <HeaderBar activePopupLink="" />
        <Layout>
          <Sidebar currentVal="organization-list" />
          <Content>
            <PageContentHeader
              headerTitle="Edit Organization"
              showSearchBar={false}
              showStatus={false}
              MapSelect={false}
            />
            <div className="Main-content-box">
              <OrganizationFormComponent FormTitle="edit-organization" />
            </div>
          </Content>
        </Layout>
      </Layout>
    </>
  );
};
